module.exports = __webpack_public_path__ + "static/media/thebluff.c9d4255f.mp3";